<script>
  import { getLoggedIn, getCartCount, subcategoryHeight } from '../../../../../../../../../js/stores';
  import { filterNavItems } from '../../../../../../../../../js/navItemFilters';
  import { trackLinkClick } from '../../../../../../../../../js/trackLinkClick';

  // Props
  export let navItems = [];
  export let isOpen = false;
  export let hasDescriptions = true;

  // Constants
  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();

  // Filter out any items that should be hidden
  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });

  let height;
  $: if (isOpen) {
    // Account for padding:
    $subcategoryHeight = height + 15 * 2;
  }
</script>

{#if isOpen}
  <div class="leftBorder" class:noDescriptions={!hasDescriptions}></div>
{/if}

<div class="SubcategoryListContainer" class:isOpen class:noDescriptions={!hasDescriptions}>
  <div bind:clientHeight={height}>
    <ul class="SubcategoryList">
      {#each filteredItems as item (item)}
        <li class:hidden={item.hidden}>
          <a
            class="link"
            id={item.id}
            href={item.url}
            use:trackLinkClick={{
              id: item.id,
              title: item.title,
              url: item.url,
            }}
          >
            <span class="title">{item.title}</span>
          </a>
        </li>
      {/each}
    </ul>
  </div>
</div>

<style>@charset "UTF-8";
.leftBorder {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 278px;
  width: 0;
  margin: 15px 0;
  border-left: 1px solid var(--color-border, #d9d9d9);
}

.SubcategoryListContainer {
  height: 100%;
  position: absolute;
  width: 220px;
  top: 0;
  left: 278px;
  margin: 15px 0;
  opacity: 0;
  visibility: hidden;
}

.SubcategoryList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.SubcategoryList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.SubcategoryList > li::before {
  display: none;
}

.noDescriptions {
  left: 238px;
}

.isOpen {
  opacity: 1;
  z-index: 1;
  visibility: visible;
}

.link {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  position: relative;
  min-height: 0;
  max-height: none;
  max-width: 278px;
  width: 100%;
  margin: 0;
  padding: 10px 20px;
  border-radius: 0;
  border: 0;
  outline: 0;
  color: var(--color-text, #1a1a1a);
  background-color: transparent;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}
.link::-moz-focus-inner {
  border: 0;
}
.link:focus {
  outline: none;
}
.link::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.link:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
@media (hover: hover) {
  .link:hover::before {
    opacity: 1;
    transform: scale(1);
  }
}
.link > * {
  position: relative;
}

.title {
  display: block;
  position: relative;
  font-size: 14px;
  line-height: 24px;
}</style>
